import {
  BasketballEventStatusId,
  BasketballIncidentId,
  CommonIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  getBlockedPocketIncidentsMap,
  PocketIncidents,
  PocketIncidentsConfig,
} from '../../configuration'

const pocketIncidents: PocketIncidents = [
  {
    incidentId: BasketballIncidentId.TvTimeout,
    title: 'TV Timeout',
  },
  {
    incidentId: BasketballIncidentId.Timeout,
    title: 'Timeout',
  },
  {
    incidentId: BasketballIncidentId.PlayUnderReview,
    title: 'Play under rev.',
  },
  {
    incidentId: CommonIncidentId.TechnicalProblems,
    title: 'Tech. problem',
  },
]

const morePocketIncidents: PocketIncidents = [
  {
    incidentId: CommonIncidentId.MatchResumed,
    title: 'Match resumed',
  },
  {
    incidentId: BasketballIncidentId.RefereeInjury,
    title: "Referee's injury",
  },
  {
    incidentId: BasketballIncidentId.BreakDuringTheGame,
    title: 'Break during the game',
  },
]

const blockedStatuses: BasketballEventStatusId[] = [
  BasketballEventStatusId.Abandoned,
  BasketballEventStatusId.Cancelled,
  BasketballEventStatusId.NotStarted,
  BasketballEventStatusId.StartDelayed,
  BasketballEventStatusId.Postponed,
  BasketballEventStatusId.FinishedAwardedWin,
  BasketballEventStatusId.FinishedRegularTime,
  BasketballEventStatusId.Interrupted,
  BasketballEventStatusId.ToFinish,
  BasketballEventStatusId.Break,
  BasketballEventStatusId.BreakAfterFirstHalf,
  BasketballEventStatusId.BreakAfterFirstQuarter,
  BasketballEventStatusId.BreakAfterSecondQuarter,
  BasketballEventStatusId.BreakAfterThirdQuarter,
  BasketballEventStatusId.BreakAfterFirstOvertime,
  BasketballEventStatusId.BreakAfterSecondOvertime,
  BasketballEventStatusId.BreakAfterThirdOvertime,
  BasketballEventStatusId.BreakAfterFourthOvertime,
]

const blockedPocketIncidentsMap = getBlockedPocketIncidentsMap(
  pocketIncidents,
  morePocketIncidents,
  blockedStatuses,
)

export const pocketIncidentsConfig: PocketIncidentsConfig = {
  pocketIncidents,
  morePocketIncidents,
  blockedPocketIncidentsMap,
}
